import React from 'react'
import gsap from "gsap";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './aboutUs.css'

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const AboutUs = (props) => {
    // console.log('props', props)
    const two = useRef(null);
    const aboutUs = useRef(null);

    useGSAP(() => {
        const pTags = two.current.querySelectorAll("p");
        gsap.from(pTags, {
            scale: 1.2,
            opacity: 0,
            stagger: 1,
            duration: 1.9,
            ease: "elastic.out",
        });
    });

    useGSAP(() => {
        gsap.from(aboutUs.current, {
            opacity: 0,
            stagger: 0.1,
            delay: 0.2,
            duration: 10,
            ease: "elastic.out",
        });
    });

    return (
        <div>
            <div className="container ourValuesContainer">
                <div className="section">
                    <div ref={two}>
                        <p className='aboutUs'>About us</p>
                        {/* <h1 className='ourValues'>At Bandara Dashboards,
                            we're more than just a tech company -
                            we're car lovers, engineers, and designers,
                            committed to delivering solutions that honor
                            the soul of your vehicle and elevate the driving
                            experience to a whole new level.
                        </h1> */}
                        <h1 ref={aboutUs} className='ourValues'>We create custom instrument clusters using the next generation of Apple CarPlay. Our engineers and designers are car lovers at heart, bringing passion and expertise to every project.
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs